import { Link } from 'react-router-dom';
import { news } from '@/mocks/news';

export default function NewsSection() {
  return (
    <section className="mx-auto max-w-6xl px-4 md:px-6 py-14 md:py-20">
      <div className="flex items-end justify-between mb-8">
        <div>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">Tin tức &amp; phân tích</h2>
          <p className="mt-2 text-foreground-600">Cập nhật tin tức thị trường vàng mới nhất.</p>
        </div>
        <Link to="/ho-tro" className="text-sm font-semibold text-primary-400 hover:text-primary-300 whitespace-nowrap cursor-pointer">
          Xem tất cả
        </Link>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
        {news.map((item) => (
          <article key={item.id} className="rounded-xl border border-background-200/60 bg-background-100 overflow-hidden hover:border-primary-500/40 transition-colors">
            <div className="h-44 w-full">
              <img src={item.image} alt={item.title} className="w-full h-full object-cover object-top" />
            </div>
            <div className="p-4 md:p-5">
              <div className="flex items-center gap-2 mb-2">
                <span className="px-2 py-0.5 rounded-full bg-accent-500/15 text-accent-400 text-xs font-semibold whitespace-nowrap">{item.category}</span>
                <span className="text-xs text-foreground-600 whitespace-nowrap">{item.date}</span>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 leading-snug">{item.title}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed hidden sm:block">{item.summary}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}